import React from 'react'

import ButtonElement from '../Button'

const Button = ({ variant = 'loading', ...props }) => (
  <ButtonElement variant={variant} {...props}>
    Loading Button
  </ButtonElement>
)

export default Button
